import { render, staticRenderFns } from "./SectionDefinition.vue?vue&type=template&id=8253d8bc&scoped=true"
import script from "./SectionDefinition.vue?vue&type=script&lang=js"
export * from "./SectionDefinition.vue?vue&type=script&lang=js"
import style0 from "./SectionDefinition.vue?vue&type=style&index=0&id=8253d8bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8253d8bc",
  null
  
)

export default component.exports